import Routines from "./routines";

export default [
  // Each object is a day
  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day1,
    title: "Moderate Core Strength IV-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day2,
    title: "Moderate Core Strength IV-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day1,
    title: "Moderate Core Strength IV-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day2,
    title: "Moderate Core Strength IV-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day1,
    title: "Moderate Core Strength IV-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day2,
    title: "Moderate Core Strength IV-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week8day1,
    title: "Moderate Core Strength IV-A",
  },
];
